import { render, staticRenderFns } from "./SelectCategory.vue?vue&type=template&id=136407bc&scoped=true&"
import script from "./SelectCategory.vue?vue&type=script&lang=js&"
export * from "./SelectCategory.vue?vue&type=script&lang=js&"
import style0 from "./SelectCategory.vue?vue&type=style&index=0&id=136407bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136407bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
